import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box } from "@mui/material";
import "../Dashboard/View/PromocodeDashboard.css";
import { useDeletePromoCode } from "../../store/Apis/StripeApi";
import { PromoAlertData } from "../../Helper";

interface PromoCodeAlertProps {
  promoAlert: PromoAlertData;
  setPromoAlert: (data: any) => void;
  deletePromoCodeRequest: any;
}
export const PromoCodeAlert = ({
  promoAlert,
  setPromoAlert,
  deletePromoCodeRequest,
}: PromoCodeAlertProps) => {
  const handleClose = () => {
    setPromoAlert((prevState: PromoAlertData) => ({
      ...prevState,
      show: false,
    }));
  };

  const handleAction = () => {
    if (promoAlert.alertType === "delete") {
      deletePromoCodeRequest();
      handleClose();
    }
  };

  return (
    <>
      <Dialog
        open={promoAlert.show}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="promo-dialog"
      >
        <DialogTitle id="promo-alert-title">
          {promoAlert.headerTitle}
        </DialogTitle>
        <DialogContent sx={{ padding: "20px 0"}}>
          <DialogContentText id="alert-dialog-description">
            {promoAlert.description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Box className="first-btn-action">
            <Button onClick={handleClose}>{promoAlert.firstAction}</Button>
          </Box>
          <Box className="sec-btn-action">
            <Button onClick={handleAction} autoFocus>
              {promoAlert.secAction}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};
